import {
	SIGN_IN_SUCCESS,
	SIGN_IN_ERROR,
	SET_ACTIVE_PAGE,
	SELECT_PORTAL_TYPE,
	SHOW_GLOBAL_APP_BAR,
} from "./actionTypes";

import storageUtil from "../../../utils/storageUtil";
import { authProps } from "../../../utils/viewUtility";
import { MODULE_NAME } from "./../constants";
import { apiReducer } from "../../../utils/reduxUtil";
import { AuthInitialStateInterface } from "./types";

const initialState: AuthInitialStateInterface = {
	token: null,
	userInfo: storageUtil.getObject(authProps.USER_DATA),
	error: null,
	activePage: "",
	portalType: null,
	showAppBar: true,
};

function loginSuccess(state: any, data: any) {
	storageUtil.saveData(authProps.SECURITY_TOKEN, data.token);
	storageUtil.saveObject(authProps.USER_DATA, data.user);
	return {
		...state,
		error: null,
		token: data.token,
		userInfo: data.user,
		pageTitle: "",
	};
}

function loginError(state: any, data: any) {
	return {
		...state,
		error: data,
	};
}

const setActivePage = (state: any, action: any) => {
	return {
		...state,
		activePage: action.activePage,
		pageTitle: action.pageTitle,
	};
};

const selectPortalType = (state: any, action: any) => {
	return {
		...state,
		portalType: action.data,
	};
};

const showGlobalAppBar = (state: any, data: any) => {
	return {
		...state,
		showAppBar: data.showAppBar,
	};
};

function authReducer(state = initialState, action: any): AuthInitialStateInterface {
	state = apiReducer(state, action, MODULE_NAME);
	switch (action.type) {
		case SIGN_IN_SUCCESS:
			return loginSuccess(state, action.data);
		case SIGN_IN_ERROR:
			return loginError(state, action.data);
		case SET_ACTIVE_PAGE:
			return setActivePage(state, action.data);
		case SELECT_PORTAL_TYPE:
			return selectPortalType(state, action);
		case SHOW_GLOBAL_APP_BAR:
			return showGlobalAppBar(state, action.data);
		default:
			return state;
	}
}

export default authReducer;
